export default __webpack_public_path__ + "static/media/diagonal-arrow-right-up.5551ef45.svg";